var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registro-content",class:[
    { 'padding-sem-checkbox': _vm.paddingSemCheckBox },
    { desabilitado: _vm.desabilitado },
    { 'sem-padding-bottom': _vm.semPaddingBottom },
    _vm.colorido ? ("registro-" + _vm.classe) : ''
  ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }